import { Anchor, Box, Container, Group, Stack, Text } from '@mantine/core';
import { IconBrandGithub, IconBrandInstagram, IconBrandTelegram, IconBrandX, IconExternalLink } from '@tabler/icons-react';
import { Link } from 'gatsby';
import React from 'react';
import * as styles from './Footer.module.css';

const columns = [
  {
    title: 'Y-DAO',
    links: [
      { label: 'About', to: '/' },
      { label: 'Manifesto', to: '/manifesto/' },
      { label: 'YD', to: '/yd/' },
    ],
  },
  {
    title: 'Build',
    links: [
      { label: 'PotBot', href: 'https://potbot.fun' },
      { label: 'Projects', to: '/projects/' },
      { label: 'GitHub', href: 'https://github.com/YD811' },
    ],
  },
  {
    title: 'Explore',
    links: [
      { label: 'HUB', to: '/hub/' },
      { label: 'Events', to: '/events/' },
      { label: '811', to: '/events/811/' },
      { label: 'Research', to: '/blog/' },
    ],
  },
];

const Footer: React.FC = () => (
  <Box component="footer" className={styles.footer}>
    <Container size="xl" px={{ base: 'md', lg: 'xl' }}>
      <div className={styles.footerGrid}>
        <Box className={styles.positioning}>
          <Link to="/" className={styles.brand}>Y-DAO</Link>
          <Text>
            A founder-led ecosystem building products, communities and cultural experiences on Solana.
          </Text>
          <Group gap="xs" mt="lg">
            <Anchor href="https://x.com/CryptoYDao" target="_blank" rel="noopener noreferrer" className={styles.social} aria-label="Y-DAO on X"><IconBrandX size={18} /></Anchor>
            <Anchor href="https://t.me/CryptoYD" target="_blank" rel="noopener noreferrer" className={styles.social} aria-label="Y-DAO on Telegram"><IconBrandTelegram size={18} /></Anchor>
            <Anchor href="https://instagram.com/dolinskiy_y" target="_blank" rel="noopener noreferrer" className={styles.social} aria-label="YD on Instagram"><IconBrandInstagram size={18} /></Anchor>
            <Anchor href="https://github.com/YD811" target="_blank" rel="noopener noreferrer" className={styles.social} aria-label="YD on GitHub"><IconBrandGithub size={18} /></Anchor>
          </Group>
        </Box>

        {columns.map((column) => (
          <Stack key={column.title} gap={10}>
            <Text className={styles.columnTitle}>{column.title}</Text>
            {column.links.map((link) => link.href ? (
              <Anchor key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {link.label} <IconExternalLink size={12} />
              </Anchor>
            ) : (
              <Anchor key={link.label} component={Link} to={link.to!} className={styles.link}>{link.label}</Anchor>
            ))}
          </Stack>
        ))}

        <Stack gap={10}>
          <Text className={styles.columnTitle}>Connect</Text>
          <Anchor href="https://x.com/CryptoYDao" target="_blank" rel="noopener noreferrer" className={styles.link}>X <IconExternalLink size={12} /></Anchor>
          <Anchor href="https://t.me/CryptoYD" target="_blank" rel="noopener noreferrer" className={styles.link}>Telegram <IconExternalLink size={12} /></Anchor>
          <Anchor href="https://instagram.com/dolinskiy_y" target="_blank" rel="noopener noreferrer" className={styles.link}>Instagram <IconExternalLink size={12} /></Anchor>
        </Stack>
      </div>

      <Group justify="space-between" align="center" className={styles.footnote}>
        <Text>© {new Date().getFullYear()} Y-DAO</Text>
        <Text>Built on Solana · Directed from Amsterdam</Text>
      </Group>
    </Container>
  </Box>
);

export default Footer;
